import { useMutation } from '@tanstack/react-query'

import { deletePaymentRequestEvidence } from '@src/api'
import { DefaultApiDeletePaymentRequestEvidenceRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useDeletePaymentRequestEvidence = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiDeletePaymentRequestEvidenceRequest) =>
      deletePaymentRequestEvidence(axiosInstance, params),
  })
}
